import React from "react";
import { useParams } from "react-router-dom";
import { appRouters } from "./routeSetup";
import AppLayout from "components/Layout";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { getUrlCodeByLanguage } from "utils";
import {
  useLayout,
  useStructure,
  useLocale,
  setLayoutState,
  setLocaleState,
} from "routes/LayoutContext";

const SUB_FOLDER = process.env.REACT_APP_SUB_FOLDER
  ? process.env.REACT_APP_SUB_FOLDER
  : "";

const BASE_FOLDER = `${SUB_FOLDER}/:locale(en|cn|tc|jp)/`;

const routers = appRouters();

type ReactProps = {
  path: string;
  authority: Boolean;
  layout: number;
  children?: Array<ReactProps>;
};

const PermissionRoute: React.FC<ReactProps> = (props) => {
  const { layout: layoutOfRoute, authority, ...restProps } = props;
  const { locale: localeFromUrl } = useParams();

  const layout = useLayout();
  const locale = useLocale();

  const setLayout = setLayoutState();
  const setLocale = setLocaleState();

  React.useEffect(() => {
    if (layoutOfRoute !== layout) {
      setLayout(layoutOfRoute);
    }
  }, [layoutOfRoute, layout, setLayout]);

  React.useEffect(() => {
    if (localeFromUrl !== locale) {
      setLocale(localeFromUrl);
    }
  }, [localeFromUrl, locale, setLocale]);

  return <Route {...restProps} />;
};

const App: React.FC = () => {
  const localeUrlCode = getUrlCodeByLanguage();
  const layoutStructure = useStructure();
  const layout = useLayout();

  return (
    <Router>
      <Switch>
        <Redirect exact from={`/`} to={`${SUB_FOLDER}/${localeUrlCode}`} />
        <Route
          path={BASE_FOLDER}
          render={() => (
            <AppLayout structure={layoutStructure} layout={layout}>
              <Switch>
                {routers.map((router, key) => {
                  return <PermissionRoute {...router} key={key} />;
                })}
              </Switch>
            </AppLayout>
          )}
        />
        <Redirect to={`${SUB_FOLDER}/${localeUrlCode}`} />
      </Switch>
    </Router>
  );
};

export default App;
